import api from "@/lib/api";

const CHUNK_SIZE = 512 * 1024;

export async function scanKartuKeluarga(file, profile, onProgress) {
  if (!/\.(pdf|jpe?g|png|webp)$/i.test(file.name) || !file.size || file.size > 10 * 1024 * 1024) {
    throw new Error("Gunakan JPG, PNG, WEBP, atau PDF berukuran lebih dari 0 byte dan maksimal 10 MB.");
  }
  let uploadId;
  const chunks = Math.ceil(file.size / CHUNK_SIZE);
  for (let index = 0; index < chunks; index += 1) {
    const form = new FormData();
    form.append("file", file.slice(index * CHUNK_SIZE, (index + 1) * CHUNK_SIZE), file.name);
    form.append("file_size", String(file.size));
    form.append("chunk_index", String(index));
    form.append("applicant_name", String(profile.namaLengkap || "").slice(0, 160));
    form.append("applicant_nik", String(profile.nik || "").replace(/\D/g, "").slice(0, 16));
    if (uploadId) form.append("upload_id", uploadId);
    onProgress?.(`Mengunggah KK ${Math.round(index / chunks * 100)}%`);
    const { data } = await api.post("/profile/extract-kk", form, {
      timeout: 180000,
      onUploadProgress: (event) => {
        const ratio = event.total ? event.loaded / event.total : 0;
        if (index === chunks - 1 && ratio === 1) onProgress?.("Membaca KK dan menghitung anggota keluarga...");
        else onProgress?.(`Mengunggah KK ${Math.round((index + ratio) / chunks * 100)}%`);
      },
    });
    if (data.complete !== false) return data;
    uploadId = data.upload_id;
  }
}
